module.exports = __webpack_public_path__ + "img/primary_9x3.0d0cda9c.svg";